import { BetDetailResponse, TableSnapshotResponse } from './../api/betDetailResponse'
import { create } from 'zustand'
import { BetDetailTab, BetDetailType, DetailGameType } from '../enum/betDetailEnum'
import { SymbolType } from '../../game/enum/SymbolType'
import { GodziType } from '../../godziDrop/enum/godziDropEnum'

export interface IBetDetailStore {
  isOpenBetDetail: boolean
  betDetailData: BetDetailResponse
  selectShowGameType: BetDetailTab
  detailGameType: DetailGameType
  currentIndex: number
  tableSnapshots: TableSnapshotResponse[]
  getCurrentTableSnapshot: () => TableSnapshotResponse
  getfreeSpinFirstPage: () => number
  isGodziWinFreeGame: () => boolean
  computed: {
    hasNext: boolean
    hasPrev: boolean
  }
}

export const initBetDetailData = {
  refNo: '',
  stake: 0,
  payout: 0,
  gameDetail: {
    snapShots: [
      {
        spin: 0,
        round: 0,
        type: BetDetailType.NormalMainGame,
        slotTable: [
          [
            {
              symbol: SymbolType.A,
              multiplier: 0,
            },
          ],
        ],
        winningReels: [
          {
            payout: 0,
            symbol: SymbolType.A,
          },
        ],
        multiplierReel: [1, 2, 3, 4, 5, 6],
        useMultiplier: true,
        finalMultiplier: 0,
      },
    ],
    godziBetDetail: {
      type: GodziType.None,
      prize: 0,
      payout: 0,
      stake: 0,
      snapShots: [
        {
          spin: 0,
          round: 0,
          type: BetDetailType.NormalMainGame,
          slotTable: [
            [
              {
                symbol: SymbolType.A,
                multiplier: 0,
              },
            ],
          ],
          winningReels: [
            {
              payout: 0,
              symbol: SymbolType.A,
            },
          ],
          multiplierReel: [1, 2, 3, 4, 5, 6],
          useMultiplier: true,
          finalMultiplier: 0,
        },
      ],
    },
  },
  isExtraBet: false,
  returnCode: 0,
  message: 'string',
  voucherStake: 0,
}

export const useBetDetailStore = create<IBetDetailStore>((set, get) => ({
  isOpenBetDetail: false,
  betDetailData: initBetDetailData,
  selectShowGameType: BetDetailTab.Normal,
  detailGameType: DetailGameType.Main,
  currentIndex: -1,
  tableSnapshots: [],
  getCurrentTableSnapshot: () => {
    const store = get()
    if (store.selectShowGameType === BetDetailTab.Godzi) {
      if (store.betDetailData.gameDetail.godziBetDetail.type === GodziType.RatioPrize
        || store.betDetailData.gameDetail.godziBetDetail.type === GodziType.FreeSpin) {
        return {
          spin: 0,
          round: 0,
          type: BetDetailType.NormalMainGame,
          slotTable: [],
          winningReels: [],
          multiplierReel: [],
          useMultiplier: false,
          finalMultiplier: 0,
        }
      }
      else {
        return store.betDetailData.gameDetail.godziBetDetail.snapShots[store.currentIndex]
      }
    }
    else {
      return store.tableSnapshots[store.currentIndex]
    }
  },
  getfreeSpinFirstPage: () => {
    const store = get()
    for (let i = 0; i < store.tableSnapshots.length; i++) {
      if (
        (store.tableSnapshots[i].type === BetDetailType.NormalFreeGame
          && store.selectShowGameType === BetDetailTab.Normal)
        || (store.tableSnapshots[i].type === BetDetailType.GodziFreeGame
          && store.selectShowGameType === BetDetailTab.Godzi)
      ) {
        return i
      }
    }
    return 0
  },
  isGodziWinFreeGame: () => {
    const store = get()
    return (
      store.betDetailData.gameDetail.godziBetDetail.type
      === GodziType.FreeGame
    )
  },
  computed: {
    get hasPrev() {
      const store = get()
      return store.currentIndex > 0
    },
    get hasNext() {
      const store = get()
      return store.currentIndex < store.tableSnapshots.length - 1
    },
  },
}))
